let plus = window.plus
/**
 * @description 判断网络状态
 */
function GetNetWorkState () {
  let NetStateStr = '未知'
  let types = {}
  types[plus.networkinfo.CONNECTION_UNKNOW] = '未知'
  types[plus.networkinfo.CONNECTION_NONE] = '未连接网络'
  types[plus.networkinfo.CONNECTION_ETHERNET] = '有线网络'
  types[plus.networkinfo.CONNECTION_WIFI] = 'WiFi网络'
  types[plus.networkinfo.CONNECTION_CELL2G] = '2G蜂窝网络'
  types[plus.networkinfo.CONNECTION_CELL3G] = '3G蜂窝网络'
  types[plus.networkinfo.CONNECTION_CELL4G] = '4G蜂窝网络'
  types[plus.networkinfo.CONNECTION_CELL5G] = '5G蜂窝网络'
  NetStateStr = types[plus.networkinfo.getCurrentType()]
  return NetStateStr
}
/**
 * @description 判断是否有网络
 * @return {boolean}
 */
function IsNetWorkCanUse () {
  return !(GetNetWorkState() === '未知' || GetNetWorkState() === '未连接网络')
}
/**
* 判断是否能下载
* @date: 2020/5/14
*/
function readyToDownloadFromNet (loadUrl, type, name, callbackOptions) {
  callbackOptions = callbackOptions || {}
  // 如果文件不存在,上网下载
  if (IsNetWorkCanUse() === true) {
    // 如果网络状态能用,联网下载
    downloadFileFromNet(loadUrl, type, name, callbackOptions)
  } else {
    callbackOptions.errorDownload && callbackOptions.errorDownload('下载失败:' + '没有网络!' + ',url:' + loadUrl)
  }
}
/**
 * 默认的options
 */
const defaultSettingOptions = {
  // 默认的下载缓存目录-存到应用的downloads
  'downloadStoragePath': '_downloads/',
  // 超时请求时间
  'timeout': 3,
  // 超时请求后的重试次数
  'retryInterval': 3,
  // 单个下载任务最大的请求时间,防止一些机型上无法触发错误回调,单位毫秒,默认10秒
  'maxTimeSingleDownloadTaskSpend': 1000 * 10,
  // 获取相对路径的函数,如果不传,则用默认的路径处理方法
  'getRelativePathFromLoadUrlCallback': null,
  // 监听进度的步长
  'ListenerProgressStep': 5
}
/**
 * @description 从网络下载文件,并通过回调函数回调
 * @param relativePath
 * @param type
 * @param name
 * @param {JSON} callbackOptions 存放各种回调函数
 * 包括  beforeDownload,downloading successDownload,errorDownload
 */
function downloadFileFromNet (relativePath, type, name, callbackOptions) {
  if (relativePath === null) { return }
  callbackOptions = callbackOptions || {}
  // 下载参数
  const options = {
    filename: `_downloads/`,
    timeout: defaultSettingOptions['timeout'],
    retryInterval: defaultSettingOptions['retryInterval']
  }
  options.filename = options.filename + name
  // 存一个最原始的地址,缓存是根据最原始的地址来的
  let originalUrl = relativePath
  // 1.下载之前的回调
  callbackOptions.beforeDownload && callbackOptions.beforeDownload()
  // 2.创建下载任务
  let dtask = plus.downloader.createDownload(originalUrl, options, (d, status) => {
    if (status === 200) {
      // 保存手机相册
      if (type === 'image' || type === 'video') {
        plus.gallery.save(d.filename, () => {}, () => {
          callbackOptions.errorDownload && callbackOptions.errorDownload('保存相册失败=' + status + '===' + relativePath)
        })
      }
    } else {
      callbackOptions.errorDownload && callbackOptions.errorDownload('下载失败=' + status + '===' + relativePath)
    }
  })
  // 3.添加进度监听器,监听步长也由外部传入
  let step = 0
  let progress = 0
  dtask.start()
  // plus.notification.setNotification('文件下载', '开始下载')
  dtask.addEventListener('statechanged', (task, status) => {
    switch (task.state) {
      case 1: // 开始
        callbackOptions.downloading && callbackOptions.downloading(0, '开始下载...')
        break
      case 2: // 已连接到服务器
        callbackOptions.downloading && callbackOptions.downloading(0, '已连接到服务器')
        break
      case 3:
        // 每隔一定的比例显示一次
        if (task.totalSize !== 0) {
          progress = task.downloadedSize / task.totalSize * 100
          // plus.notification.setProgress(progress)
          progress = Math.round(progress)
          if (progress - step >= defaultSettingOptions.ListenerProgressStep) {
            step = progress
            callbackOptions.downloading && callbackOptions.downloading(parseInt(progress) >= 95 ? 100 : parseInt(progress), null)
          }
        }
        break
      case 4: // 下载完成
        // plus.notification.compProgressNotification('下载完成')
        callbackOptions.downloading && callbackOptions.downloading(100, '下载完成')
        break
    }
  })
}
export {
  readyToDownloadFromNet
}
